import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  close() {
    // Remove the alert element from the DOM
    this.element.remove();
  }
}